// extracted by mini-css-extract-plugin
export default {"travel-health-notices":"TravelHealthNotices_travel-health-notices__6xfR4"};